import React from "react"
import { StyleSheet, TouchableOpacity } from "react-native"
import { useTheme } from '@react-navigation/native'
import { Theme } from '@theme'
import { Text, Icon, IconName } from '@components'
import { useLanguage } from '@context'

export const AddContactButton = ({onPress, text, icon, isBig = false, disabled = false}: {onPress?: () => void, text?: string, icon?: IconName, isBig?: boolean, disabled?: boolean}) => {
    const theme = useTheme()
    const { t } = useLanguage()
    const styles = getStyle(theme, isBig)

    return (
        <TouchableOpacity
            style={[styles.addButton, disabled && styles.addButtonDisabled]}
            onPress={onPress}
            disabled={disabled}
        >
            <Icon
            name={icon || "userPlus"}
            size={isBig? theme.iconSize.medium : theme.iconSize.extraSmall}
            color={theme.colors.primary}
            />
            <Text 
            type={isBig? "body" : "bodyExtraSmall"}
            color={theme.colors.primary}
            style={styles.addButtonText}
            >
            {text || t('common.add')}
            </Text>
        </TouchableOpacity>
    )
}

const getStyle = (theme: Theme, isBig: boolean) =>
    StyleSheet.create({
        addButton: {
            flexDirection: 'row',
            alignItems: 'center',
            paddingHorizontal: isBig? theme.spacing.lg : theme.spacing.md,
            paddingVertical: isBig? theme.spacing.md : theme.spacing.sm,
            backgroundColor: 'rgba(85, 152, 210, 0.15)',
            borderRadius: isBig? theme.border.jumbo : theme.border.large,
        },
        addButtonText: {
            marginLeft: theme.spacing.xs,
        },
        addButtonDisabled: {
            opacity: 0.6,
        },
    })